var scope_0 = require('/Users/mattk/Desktop/Terranova/terranova-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/659549bf4ceb90e8375ec578031d0c52.js').default;
var scope_1 = require('/Users/mattk/Desktop/Terranova/terranova-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_2 = require('/Users/mattk/Desktop/Terranova/terranova-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/eb31f34aa6e95995a6ec8b395ab26ff3.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    